// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Function_Uncurried from "../Data.Function.Uncurried/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Uncurried from "../Effect.Uncurried/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Specular_Internal_Incremental from "../Specular.Internal.Incremental/index.js";
import * as Specular_Internal_Incremental_Node from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular_Internal_Incremental_Optional from "../Specular.Internal.Incremental.Optional/index.js";
import * as Specular_Internal_Profiling from "../Specular.Internal.Profiling/index.js";
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Class.monadEffectEffect);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var Event = function (x) {
    return x;
};
var DynPure = /* #__PURE__ */ (function () {
    function DynPure(value0) {
        this.value0 = value0;
    };
    DynPure.create = function (value0) {
        return new DynPure(value0);
    };
    return DynPure;
})();
var DynNode = /* #__PURE__ */ (function () {
    function DynNode(value0) {
        this.value0 = value0;
    };
    DynNode.create = function (value0) {
        return new DynNode(value0);
    };
    return DynNode;
})();
var Behavior = function (x) {
    return x;
};
var uniqDynPureBy = function (v) {
    return function (v1) {
        if (v1 instanceof DynPure) {
            return v1;
        };
        if (v1 instanceof DynNode) {
            return Effect_Unsafe.unsafePerformEffect(function __do() {
                var n = Specular_Internal_Incremental.uniqBy(Data_Function_Uncurried.mkFn2(v), v1.value0);
                Specular_Internal_Incremental_Node.annotate(n, "uniqDyn");
                return new DynNode(n);
            });
        };
        throw new Error("Failed pattern match at Specular.FRP.Base (line 367, column 1 - line 367, column 73): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var uniqDynPure = function (dictEq) {
    return uniqDynPureBy(Data_Eq.eq(dictEq));
};
var traceNode = function (handler) {
    return function (input) {
        return Effect_Unsafe.unsafePerformEffect(function __do() {
            var n = Specular_Internal_Incremental.traceChanges(Effect_Uncurried.mkEffectFn1(handler), input);
            Specular_Internal_Incremental_Node.annotate(n, "trace");
            return n;
        });
    };
};
var traceEventIO = function (handler) {
    return function (v) {
        return traceNode(handler)(v);
    };
};
var traceDynIO = function (v) {
    return function (v1) {
        if (v1 instanceof DynPure) {
            return Effect_Unsafe.unsafePerformEffect(function __do() {
                v(v1.value0)();
                return new DynPure(v1.value0);
            });
        };
        if (v1 instanceof DynNode) {
            return new DynNode(traceNode(v)(v1.value0));
        };
        throw new Error("Failed pattern match at Specular.FRP.Base (line 473, column 1 - line 473, column 69): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var $$switch = function (v) {
    if (v instanceof DynPure) {
        return v.value0;
    };
    if (v instanceof DynNode) {
        return Effect_Unsafe.unsafePerformEffect(function __do() {
            var n = Specular_Internal_Incremental["switch"](false, v.value0, function (v1) {
                return v1;
            });
            Specular_Internal_Incremental_Node.annotate(n, "switch");
            return n;
        });
    };
    throw new Error("Failed pattern match at Specular.FRP.Base (line 381, column 1 - line 381, column 49): " + [ v.constructor.name ]);
};
var subscribeNode = function (dictMonadEffect) {
    var liftEffect1 = Effect_Class.liftEffect(dictMonadEffect);
    return function (dictMonadCleanup) {
        var bind1 = Control_Bind.bind((dictMonadCleanup.Monad0()).Bind1());
        var onCleanup = Control_Monad_Cleanup.onCleanup(dictMonadCleanup);
        return function (handler) {
            return function (event) {
                return bind1(liftEffect1(function () {
                    return Specular_Internal_Incremental.subscribeNode(handler, event);
                }))(function (unsub) {
                    return onCleanup(unsub);
                });
            };
        };
    };
};
var subscribeEvent_ = function (dictMonadEffect) {
    var subscribeNode1 = subscribeNode(dictMonadEffect);
    return function (dictMonadCleanup) {
        var subscribeNode2 = subscribeNode1(dictMonadCleanup);
        return function (handler) {
            return function (v) {
                return subscribeNode2(handler)(v);
            };
        };
    };
};
var subscribeDyn_ = function (dictMonadFRP) {
    var MonadEffect0 = dictMonadFRP.MonadEffect0();
    var liftEffect1 = Effect_Class.liftEffect(MonadEffect0);
    var MonadCleanup1 = dictMonadFRP.MonadCleanup1();
    var discard2 = discard((MonadCleanup1.Monad0()).Bind1());
    var subscribeNode1 = subscribeNode(MonadEffect0)(MonadCleanup1);
    return function (v) {
        return function (v1) {
            if (v1 instanceof DynPure) {
                return liftEffect1(v(v1.value0));
            };
            if (v1 instanceof DynNode) {
                return discard2(subscribeNode1(v)(v1.value0))(function () {
                    return liftEffect1(function __do() {
                        var currentValue = Specular_Internal_Incremental_Node.valueExc(v1.value0);
                        return liftEffect(v(currentValue))();
                    });
                });
            };
            throw new Error("Failed pattern match at Specular.FRP.Base (line 397, column 1 - line 402, column 12): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
var stabilize = Specular_Internal_Incremental.stabilize;
var readNode = function (node) {
    var handler = function (v) {
        return Data_Unit.unit;
    };
    return function __do() {
        Specular_Internal_Incremental.addObserver(node, handler);
        var value = Specular_Internal_Incremental_Node.get_value(node);
        Specular_Internal_Incremental.removeObserver(node, handler);
        return Specular_Internal_Incremental_Optional.fromSome(value);
    };
};
var readDynamic = function (dictMonadEffect) {
    var pure2 = Control_Applicative.pure((dictMonadEffect.Monad0()).Applicative0());
    var liftEffect1 = Effect_Class.liftEffect(dictMonadEffect);
    return function (v) {
        if (v instanceof DynPure) {
            return pure2(v.value0);
        };
        if (v instanceof DynNode) {
            return liftEffect1(function __do() {
                var mark = Specular_Internal_Profiling.begin("readDynamic");
                var result = readNode(v.value0)();
                Specular_Internal_Profiling.end(mark);
                return result;
            });
        };
        throw new Error("Failed pattern match at Specular.FRP.Base (line 457, column 1 - line 457, column 61): " + [ v.constructor.name ]);
    };
};
var readDynamic1 = /* #__PURE__ */ readDynamic(Effect_Class.monadEffectEffect);
var readBehavior = function (v) {
    return readDynamic1(v);
};
var pull = function (dictMonadEffect) {
    return Effect_Class.liftEffect(dictMonadEffect);
};
var newEvent = function (dictMonadEffect) {
    return Effect_Class.liftEffect(dictMonadEffect)(function __do() {
        var evt = Specular_Internal_Incremental.newEvent();
        Specular_Internal_Incremental_Node.annotate(Specular_Internal_Incremental.readEvent(evt), "root Event");
        return {
            event: Specular_Internal_Incremental.readEvent(evt),
            fire: function (x) {
                return function __do() {
                    var name = Specular_Internal_Incremental_Node.get_name(Specular_Internal_Incremental.readEvent(evt));
                    var mark = Specular_Internal_Profiling.begin("fire " + name);
                    Specular_Internal_Incremental.triggerEvent(evt, x);
                    stabilize();
                    return Specular_Internal_Profiling.end(mark);
                };
            }
        };
    });
};
var newDynamic = function (dictMonadEffect) {
    var liftEffect1 = Effect_Class.liftEffect(dictMonadEffect);
    return function (initial) {
        return liftEffect1(function __do() {
            var $$var = Specular_Internal_Incremental.newVar(initial);
            Specular_Internal_Incremental_Node.annotate(Specular_Internal_Incremental.readVar($$var), "root Dynamic");
            var dynamic = new DynNode(Specular_Internal_Incremental.readVar($$var));
            return {
                dynamic: dynamic,
                read: readDynamic1(dynamic),
                set: function (x) {
                    return function __do() {
                        var name = Specular_Internal_Incremental_Node.get_name(Specular_Internal_Incremental.readVar($$var));
                        var mark = Specular_Internal_Profiling.begin("set " + name);
                        Specular_Internal_Incremental.setVar($$var, x);
                        stabilize();
                        return Specular_Internal_Profiling.end(mark);
                    };
                },
                modify: function (f) {
                    return function __do() {
                        var name = Specular_Internal_Incremental_Node.get_name(Specular_Internal_Incremental.readVar($$var));
                        var mark = Specular_Internal_Profiling.begin("modify " + name);
                        var x = Specular_Internal_Incremental_Node.valueExc(Specular_Internal_Incremental.readVar($$var));
                        Specular_Internal_Incremental.setVar($$var, f(x));
                        stabilize();
                        return Specular_Internal_Profiling.end(mark);
                    };
                }
            };
        });
    };
};
var newDynamic1 = /* #__PURE__ */ newDynamic(Effect_Class.monadEffectEffect);
var newBehaviorEffect = function (initialValue) {
    return function __do() {
        var v = newDynamic1(initialValue)();
        return {
            behavior: v.dynamic,
            set: v.set
        };
    };
};
var newBehavior = function (dictMonadEffect) {
    var liftEffect1 = Effect_Class.liftEffect(dictMonadEffect);
    return function (initialValue) {
        return liftEffect1(newBehaviorEffect(initialValue));
    };
};
var never = /* #__PURE__ */ Specular_Internal_Incremental.readEvent(/* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(Specular_Internal_Incremental.newEvent));
var monadFRP = function (dictMonadEffect) {
    return function (dictMonadCleanup) {
        return {
            MonadEffect0: function () {
                return dictMonadEffect;
            },
            MonadCleanup1: function () {
                return dictMonadCleanup;
            }
        };
    };
};
var leftmost = function (events) {
    return Effect_Unsafe.unsafePerformEffect(function __do() {
        var n = Specular_Internal_Incremental.leftmost(map(function (v) {
            return v;
        })(events));
        Specular_Internal_Incremental_Node.annotate(n, "leftmost");
        return n;
    });
};
var semigroupEvent = {
    append: function (e1) {
        return function (e2) {
            return leftmost([ e1, e2 ]);
        };
    }
};
var monoidEvent = {
    mempty: never,
    Semigroup0: function () {
        return semigroupEvent;
    }
};
var functorEvent = {
    map: function (f) {
        return function (v) {
            return Effect_Unsafe.unsafePerformEffect(function __do() {
                var n = Specular_Internal_Incremental.mapOptional(function ($278) {
                    return Specular_Internal_Incremental_Optional.some(f($278));
                }, v);
                Specular_Internal_Incremental_Node.annotate(n, "mapEvent");
                return n;
            });
        };
    }
};
var map3 = /* #__PURE__ */ Data_Functor.map(functorEvent);
var voidRight = /* #__PURE__ */ Data_Functor.voidRight(functorEvent);
var sampleAt = function (v) {
    return function (v1) {
        if (v1 instanceof DynPure) {
            return map3(function (v2) {
                return v2(v1.value0);
            })(v);
        };
        if (v1 instanceof DynNode) {
            return Effect_Unsafe.unsafePerformEffect(function __do() {
                var n = Specular_Internal_Incremental.sample(function (a, b) {
                    return Specular_Internal_Incremental_Optional.some(b(a));
                }, v1.value0, v);
                Specular_Internal_Incremental_Node.annotate(n, "sampleAt");
                return n;
            });
        };
        throw new Error("Failed pattern match at Specular.FRP.Base (line 145, column 1 - line 145, column 64): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var functorDynamic = {
    map: function (v) {
        return function (v1) {
            if (v1 instanceof DynPure) {
                return new DynPure(v(v1.value0));
            };
            if (v1 instanceof DynNode) {
                return new DynNode(Effect_Unsafe.unsafePerformEffect(function __do() {
                    var n = Specular_Internal_Incremental.map(v, v1.value0);
                    Specular_Internal_Incremental_Node.annotate(n, "map " + Specular_Internal_Incremental_Node.name(v1.value0));
                    return n;
                }));
            };
            throw new Error("Failed pattern match at Specular.FRP.Base (line 242, column 1 - line 247, column 11): " + [ v.constructor.name, v1.constructor.name ]);
        };
    }
};
var map4 = /* #__PURE__ */ Data_Functor.map(functorDynamic);
var map2 = function (v) {
    return function (v1) {
        return function (v2) {
            if (v1 instanceof DynPure) {
                return map4(v(v1.value0))(v2);
            };
            if (v2 instanceof DynPure) {
                return map4(function (x) {
                    return v(x)(v2.value0);
                })(v1);
            };
            if (v1 instanceof DynNode && v2 instanceof DynNode) {
                return new DynNode(Effect_Unsafe.unsafePerformEffect(function __do() {
                    var n = Specular_Internal_Incremental.map2(Data_Function_Uncurried.mkFn2(v), v1.value0, v2.value0);
                    Specular_Internal_Incremental_Node.annotate(n, "map2 (" + (Specular_Internal_Incremental_Node.name(v1.value0) + (") (" + (Specular_Internal_Incremental_Node.name(v2.value0) + ")"))));
                    return n;
                }));
            };
            throw new Error("Failed pattern match at Specular.FRP.Base (line 257, column 1 - line 257, column 75): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
        };
    };
};
var functorBehavior = functorDynamic;
var foldDynMaybe = function (dictMonadFRP) {
    var MonadCleanup1 = dictMonadFRP.MonadCleanup1();
    var Monad0 = MonadCleanup1.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind1 = Control_Bind.bind(Bind1);
    var MonadEffect0 = dictMonadFRP.MonadEffect0();
    var liftEffect1 = Effect_Class.liftEffect(MonadEffect0);
    var discard2 = discard(Bind1);
    var subscribeNode1 = subscribeNode(MonadEffect0)(MonadCleanup1);
    var pure2 = Control_Applicative.pure(Monad0.Applicative0());
    return function (f) {
        return function (initial) {
            return function (v) {
                return bind1(liftEffect1(function __do() {
                    var n = Specular_Internal_Incremental.fold(function (a, b) {
                        return Data_Maybe.maybe(Specular_Internal_Incremental_Optional.none)(Specular_Internal_Incremental_Optional.some)(f(a)(b));
                    }, initial, v);
                    Specular_Internal_Incremental_Node.annotate(n, "foldDynMaybe");
                    return n;
                }))(function (n) {
                    return discard2(subscribeNode1(function (v1) {
                        return pure(Data_Unit.unit);
                    })(n))(function () {
                        return pure2(new DynNode(n));
                    });
                });
            };
        };
    };
};
var holdUniqDynBy = function (dictMonadFRP) {
    var foldDynMaybe1 = foldDynMaybe(dictMonadFRP);
    return function (eq) {
        return foldDynMaybe1(function ($$new) {
            return function (old) {
                var $236 = eq($$new)(old);
                if ($236) {
                    return Data_Maybe.Nothing.value;
                };
                return new Data_Maybe.Just($$new);
            };
        });
    };
};
var foldDyn = function (dictMonadFRP) {
    var MonadCleanup1 = dictMonadFRP.MonadCleanup1();
    var Monad0 = MonadCleanup1.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind1 = Control_Bind.bind(Bind1);
    var MonadEffect0 = dictMonadFRP.MonadEffect0();
    var liftEffect1 = Effect_Class.liftEffect(MonadEffect0);
    var discard2 = discard(Bind1);
    var subscribeNode1 = subscribeNode(MonadEffect0)(MonadCleanup1);
    var pure2 = Control_Applicative.pure(Monad0.Applicative0());
    return function (f) {
        return function (initial) {
            return function (v) {
                return bind1(liftEffect1(function __do() {
                    var n = Specular_Internal_Incremental.fold(function (a, b) {
                        return Specular_Internal_Incremental_Optional.some(f(a)(b));
                    }, initial, v);
                    Specular_Internal_Incremental_Node.annotate(n, "foldDyn");
                    return n;
                }))(function (n) {
                    return discard2(subscribeNode1(function (v1) {
                        return pure(Data_Unit.unit);
                    })(n))(function () {
                        return pure2(new DynNode(n));
                    });
                });
            };
        };
    };
};
var holdDyn = function (dictMonadFRP) {
    return foldDyn(dictMonadFRP)(function (x) {
        return function (v) {
            return x;
        };
    });
};
var filterMapEvent = function (f) {
    return function (v) {
        return Effect_Unsafe.unsafePerformEffect(function __do() {
            var n = Specular_Internal_Incremental.mapOptional((function () {
                var $279 = Data_Maybe.maybe(Specular_Internal_Incremental_Optional.none)(Specular_Internal_Incremental_Optional.some);
                return function ($280) {
                    return $279(f($280));
                };
            })(), v);
            Specular_Internal_Incremental_Node.annotate(n, "filterMapEvent");
            return n;
        });
    };
};
var filterJustEvent = /* #__PURE__ */ filterMapEvent(identity);
var filterEvent = function (f) {
    return function (v) {
        return Effect_Unsafe.unsafePerformEffect(function __do() {
            var n = Specular_Internal_Incremental.mapOptional(function (x) {
                var $244 = f(x);
                if ($244) {
                    return Specular_Internal_Incremental_Optional.some(x);
                };
                return Specular_Internal_Incremental_Optional.none;
            }, v);
            Specular_Internal_Incremental_Node.annotate(n, "filterEvent");
            return n;
        });
    };
};
var dynToNode = function (v) {
    if (v instanceof DynPure) {
        return Effect_Unsafe.unsafePerformEffect(function __do() {
            var n = Specular_Internal_Incremental.constant(v.value0);
            Specular_Internal_Incremental_Node.annotate(n, "pure");
            return n;
        });
    };
    if (v instanceof DynNode) {
        return v.value0;
    };
    throw new Error("Failed pattern match at Specular.FRP.Base (line 276, column 1 - line 276, column 43): " + [ v.constructor.name ]);
};
var mapAsync = function (f) {
    return function (dyn) {
        return new DynNode(Effect_Unsafe.unsafePerformEffect((function () {
            var node = dynToNode(dyn);
            return function __do() {
                var n = Specular_Internal_Incremental.mapAsync(f, node);
                Specular_Internal_Incremental_Node.annotate(n, "mapAsync " + Specular_Internal_Incremental_Node.name(node));
                return n;
            };
        })()));
    };
};
var mapN = function (f) {
    return function (inputs) {
        return new DynNode(Effect_Unsafe.unsafePerformEffect((function () {
            var inputs$prime = map(dynToNode)(inputs);
            return function __do() {
                var n = Specular_Internal_Incremental.mapN(f, inputs$prime);
                Specular_Internal_Incremental_Node.annotate(n, "mapN");
                return n;
            };
        })()));
    };
};
var current = Behavior;
var tagDyn = function (dyn) {
    return function (event) {
        return sampleAt(voidRight(identity)(event))(current(dyn));
    };
};
var changed = function (v) {
    if (v instanceof DynPure) {
        return never;
    };
    if (v instanceof DynNode) {
        return v.value0;
    };
    throw new Error("Failed pattern match at Specular.FRP.Base (line 234, column 1 - line 234, column 42): " + [ v.constructor.name ]);
};
var changed_ = /* #__PURE__ */ (function () {
    var $281 = Data_Functor["void"](functorDynamic);
    return function ($282) {
        return changed($281($282));
    };
})();
var latestJust = function (dictMonadFRP) {
    var bind1 = Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1());
    var readDynamic2 = readDynamic(dictMonadFRP.MonadEffect0());
    var foldDynMaybe1 = foldDynMaybe(dictMonadFRP);
    return function (dyn) {
        return bind1(readDynamic2(dyn))(function (currentValue) {
            return foldDynMaybe1(function ($$new) {
                return function (v) {
                    return map1(Data_Maybe.Just.create)($$new);
                };
            })(currentValue)(changed(dyn));
        });
    };
};
var uniqDynBy = function (dictMonadFRP) {
    var Monad0 = (dictMonadFRP.MonadCleanup1()).Monad0();
    var pure2 = Control_Applicative.pure(Monad0.Applicative0());
    var Bind1 = Monad0.Bind1();
    var bind1 = Control_Bind.bind(Bind1);
    var liftEffect1 = Effect_Class.liftEffect(dictMonadFRP.MonadEffect0());
    var holdUniqDynBy1 = holdUniqDynBy(dictMonadFRP);
    var discard2 = discard(Bind1);
    return function (v) {
        return function (v1) {
            if (v1 instanceof DynPure) {
                return pure2(v1);
            };
            if (v1 instanceof DynNode) {
                var handler = function (v2) {
                    return Data_Unit.unit;
                };
                return bind1(liftEffect1(function __do() {
                    Specular_Internal_Incremental.addObserver(v1.value0, handler);
                    return Specular_Internal_Incremental_Node.valueExc(v1.value0);
                }))(function (initialValue) {
                    return bind1(holdUniqDynBy1(v)(initialValue)(changed(v1)))(function (uniqDyn_) {
                        return discard2(liftEffect1(function () {
                            return Specular_Internal_Incremental.removeObserver(v1.value0, handler);
                        }))(function () {
                            return pure2(uniqDyn_);
                        });
                    });
                });
            };
            throw new Error("Failed pattern match at Specular.FRP.Base (line 345, column 1 - line 345, column 89): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
var uniqDyn = function (dictMonadFRP) {
    var uniqDynBy1 = uniqDynBy(dictMonadFRP);
    return function (dictEq) {
        return uniqDynBy1(Data_Eq.eq(dictEq));
    };
};
var attachDynWith = function (f) {
    return function (dyn) {
        return function (event) {
            return sampleAt(map3(Data_Function.flip(f))(event))(current(dyn));
        };
    };
};
var applyDynamic = {
    apply: function (v) {
        return function (v1) {
            if (v instanceof DynPure) {
                return map4(v.value0)(v1);
            };
            if (v1 instanceof DynPure) {
                return map4(function (v2) {
                    return v2(v1.value0);
                })(v);
            };
            if (v instanceof DynNode && v1 instanceof DynNode) {
                return new DynNode(Effect_Unsafe.unsafePerformEffect(function __do() {
                    var n = Specular_Internal_Incremental.map2(Data_Function_Uncurried.mkFn2(Data_Function.apply), v.value0, v1.value0);
                    Specular_Internal_Incremental_Node.annotate(n, "apply (" + (Specular_Internal_Incremental_Node.name(v.value0) + (") (" + (Specular_Internal_Incremental_Node.name(v1.value0) + ")"))));
                    return n;
                }));
            };
            throw new Error("Failed pattern match at Specular.FRP.Base (line 249, column 1 - line 255, column 11): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    Functor0: function () {
        return functorDynamic;
    }
};
var lift2 = /* #__PURE__ */ Control_Apply.lift2(applyDynamic);
var bindDynamic = {
    bind: function (v) {
        return function (v1) {
            if (v instanceof DynPure) {
                return v1(v.value0);
            };
            if (v instanceof DynNode) {
                return new DynNode(Effect_Unsafe.unsafePerformEffect(function __do() {
                    var n = Specular_Internal_Incremental.bind_(v.value0, function (x) {
                        return dynToNode(v1(x));
                    });
                    Specular_Internal_Incremental_Node.annotate(n, "bindDynamic");
                    return n;
                }));
            };
            throw new Error("Failed pattern match at Specular.FRP.Base (line 388, column 1 - line 393, column 11): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    Apply0: function () {
        return applyDynamic;
    }
};
var bindBehavior = bindDynamic;
var semigroupDynamic = function (dictSemigroup) {
    return {
        append: lift2(Data_Semigroup.append(dictSemigroup))
    };
};
var applicativeDynamic = /* #__PURE__ */ (function () {
    return {
        pure: DynPure.create,
        Apply0: function () {
            return applyDynamic;
        }
    };
})();
var pure1 = /* #__PURE__ */ Control_Applicative.pure(applicativeDynamic);
var heytingAlgebraDynamic = function (dictHeytingAlgebra) {
    return {
        tt: pure1(Data_HeytingAlgebra.tt(dictHeytingAlgebra)),
        ff: pure1(Data_HeytingAlgebra.ff(dictHeytingAlgebra)),
        implies: lift2(Data_HeytingAlgebra.implies(dictHeytingAlgebra)),
        conj: lift2(Data_HeytingAlgebra.conj(dictHeytingAlgebra)),
        disj: lift2(Data_HeytingAlgebra.disj(dictHeytingAlgebra)),
        not: map4(Data_HeytingAlgebra.not(dictHeytingAlgebra))
    };
};
var monadDynamic = {
    Applicative0: function () {
        return applicativeDynamic;
    },
    Bind1: function () {
        return bindDynamic;
    }
};
var monoidDynamic = function (dictMonoid) {
    var semigroupDynamic1 = semigroupDynamic(dictMonoid.Semigroup0());
    return {
        mempty: pure1(Data_Monoid.mempty(dictMonoid)),
        Semigroup0: function () {
            return semigroupDynamic1;
        }
    };
};
var subscribeDyn = function (dictMonadFRP) {
    var MonadCleanup1 = dictMonadFRP.MonadCleanup1();
    var Monad0 = MonadCleanup1.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind1 = Control_Bind.bind(Bind1);
    var MonadEffect0 = dictMonadFRP.MonadEffect0();
    var liftEffect1 = Effect_Class.liftEffect(MonadEffect0);
    var pure2 = Control_Applicative.pure(Monad0.Applicative0());
    var discard2 = discard(Bind1);
    var subscribeNode1 = subscribeNode(MonadEffect0)(MonadCleanup1);
    return function (v) {
        return function (v1) {
            if (v1 instanceof DynPure) {
                return bind1(liftEffect1(v(v1.value0)))(function (result) {
                    return pure2(pure1(result));
                });
            };
            if (v1 instanceof DynNode) {
                return bind1(liftEffect1(function __do() {
                    var evt = Specular_Internal_Incremental.newEvent();
                    Specular_Internal_Incremental_Node.annotate(Specular_Internal_Incremental.readEvent(evt), "subscribeDyn");
                    return evt;
                }))(function (evt) {
                    return discard2(subscribeNode1(function (x) {
                        return function __do() {
                            var value = v(x)();
                            Specular_Internal_Incremental.triggerEvent(evt, value);
                            return stabilize();
                        };
                    })(v1.value0))(function () {
                        return liftEffect1(function __do() {
                            var currentValue = Specular_Internal_Incremental_Node.valueExc(v1.value0);
                            var initialResult = v(currentValue)();
                            Specular_Internal_Incremental_Node.set_value(Specular_Internal_Incremental.readEvent(evt), Specular_Internal_Incremental_Optional.some(initialResult));
                            return new DynNode(Specular_Internal_Incremental.readEvent(evt));
                        });
                    });
                });
            };
            throw new Error("Failed pattern match at Specular.FRP.Base (line 411, column 1 - line 416, column 19): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
var applyBehavior = applyDynamic;
var applicativeBehavior = applicativeDynamic;
var monadBehavior = {
    Applicative0: function () {
        return applicativeBehavior;
    },
    Bind1: function () {
        return bindBehavior;
    }
};
var annotated = function (v) {
    return function (v1) {
        if (v1 instanceof DynPure) {
            return v1;
        };
        if (v1 instanceof DynNode) {
            return Effect_Unsafe.unsafePerformEffect(function __do() {
                Specular_Internal_Incremental_Node.annotate(v1.value0, v);
                return v1;
            });
        };
        throw new Error("Failed pattern match at Specular.FRP.Base (line 485, column 1 - line 485, column 56): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var annotate = function (dictMonadEffect) {
    var pure2 = Control_Applicative.pure((dictMonadEffect.Monad0()).Applicative0());
    var liftEffect1 = Effect_Class.liftEffect(dictMonadEffect);
    return function (v) {
        return function (v1) {
            if (v instanceof DynPure) {
                return pure2(Data_Unit.unit);
            };
            if (v instanceof DynNode) {
                return liftEffect1(function () {
                    return Specular_Internal_Incremental_Node.annotate(v.value0, v1);
                });
            };
            throw new Error("Failed pattern match at Specular.FRP.Base (line 491, column 1 - line 491, column 71): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
var _subscribeEvent = function (handler, v) {
    return Specular_Internal_Incremental.subscribeNode(handler, v);
};
export {
    never,
    leftmost,
    filterEvent,
    filterMapEvent,
    filterJustEvent,
    pull,
    sampleAt,
    readBehavior,
    current,
    changed,
    changed_,
    $$switch as switch,
    tagDyn,
    attachDynWith,
    latestJust,
    readDynamic,
    newDynamic,
    holdDyn,
    foldDyn,
    foldDynMaybe,
    holdUniqDynBy,
    uniqDynBy,
    uniqDyn,
    uniqDynPureBy,
    uniqDynPure,
    newEvent,
    newBehavior,
    subscribeEvent_,
    subscribeDyn_,
    subscribeDyn,
    _subscribeEvent,
    traceEventIO,
    traceDynIO,
    annotate,
    annotated,
    map2,
    mapN,
    mapAsync,
    functorBehavior,
    applyBehavior,
    applicativeBehavior,
    bindBehavior,
    monadBehavior,
    semigroupEvent,
    monoidEvent,
    functorEvent,
    functorDynamic,
    applyDynamic,
    applicativeDynamic,
    bindDynamic,
    monadDynamic,
    monadFRP,
    heytingAlgebraDynamic,
    semigroupDynamic,
    monoidDynamic
};
export {
    Async,
    Sync,
    Finished,
    InProgress
} from "../Specular.Internal.Incremental/index.js";
